import { Component } from "react";
import { Box } from "@chakra-ui/react";
import NavigationBar from "src/components/NavigationBar";
import AccountCard from "./AccountCard";
import Buttons from "./Buttons";
import SignOutDialog from "src/modules/auth/components/SignOutDialog";
import DeleteAccountDialog from "src/modules/auth/components/DeleteAccountDialog";
import RenameFamilyDialog from "./RenameFamilyDialog";
import ResetAppDialog from "./ResetAppDialog";
import PremiumWarningDialog from "./PremiumWarningDialog";

export default class MyAccount extends Component {
  state = {
    showSignOutDialog: false,
    showRenameFamilyDialog: false,
    showResetAppDialog: false,
    showAccountDeleteDialog: false,
    showPremiumWarningDialog: false
  };

  openSignOut = () => {
    this.setState({ showSignOutDialog: true });
  };
  closeSignOut = () => this.setState({ showSignOutDialog: false });

  openResetAppDialog = () => {
    this.setState({ showResetAppDialog: true });
  };
  dismissResetAppDialog = () => this.setState({ showResetAppDialog: false });

  openRenameFamilyDialog = () =>
    this.setState({ showRenameFamilyDialog: true });
  dismissRenameFamilyDialog = () =>
    this.setState({ showRenameFamilyDialog: false });

  openDeleteAccountDialog = () =>
    this.setState({ showAccountDeleteDialog: true });
  dismissDeleteAccountDialog = () =>
    this.setState({ showAccountDeleteDialog: false });

  openPremiumWarningDialog = () =>
    this.setState({ showPremiumWarningDialog: true });
  dismissPremiumWarningDialog = () =>
    this.setState({ showPremiumWarningDialog: false });

  render() {
    const {
      showSignOutDialog,
      showRenameFamilyDialog,
      showResetAppDialog,
      showAccountDeleteDialog,
      showPremiumWarningDialog
    } = this.state;
    const {
      hasPremium,
      canManageSubscription,
      familyName,
      email,
      isLoggedIn,
      onClose,
      onBack,
      flow,
      app,
      subscription
    } = this.props;

    return (
      <>
        <ResetAppDialog
          isOpen={showResetAppDialog}
          onDismiss={this.dismissResetAppDialog}
          onReset={app.reset}
        />
        {showSignOutDialog && (
          <SignOutDialog onSignOut={app.reset} close={this.closeSignOut} />
        )}

        <RenameFamilyDialog
          isOpen={showRenameFamilyDialog}
          onDismiss={this.dismissRenameFamilyDialog}
        />

        {showAccountDeleteDialog && (
          <DeleteAccountDialog onDismiss={this.dismissDeleteAccountDialog} />
        )}
        {showPremiumWarningDialog && (
          <PremiumWarningDialog
            subscription={subscription}
            onDismiss={this.dismissPremiumWarningDialog}
          />
        )}
        <NavigationBar headingKey="account" onBack={onBack} onClose={onClose} />
        <Box px="24px" bg="surfaceElevated1" mt="24px">
          <AccountCard
            hasPremium={hasPremium}
            familyName={familyName}
            email={email}
            openRenameFamilyDialog={this.openRenameFamilyDialog}
          />
          <Buttons
            mt="32px"
            hasPremium={hasPremium}
            canManageSubscription={canManageSubscription}
            isLoggedIn={isLoggedIn}
            flow={flow}
            onSignOut={this.openSignOut}
            onReset={this.openResetAppDialog}
            openDeleteAccountDialog={this.openDeleteAccountDialog}
            openPremiumWarningDialog={this.openPremiumWarningDialog}
          />
        </Box>
      </>
    );
  }
}
